var exports = {
  "tB": "ContextMenu.module__backdrop___dVpuV1",
  "D8": "ContextMenu.module__contextMenuPositioner___dVpuV1",
  "He": "ContextMenu.module__contextMenu___dVpuV1",
  "KY": "ContextMenu.module__menuScroller___dVpuV1",
  "NC": "ContextMenu.module__menuScrollerContent___dVpuV1",
  "AS": "ContextMenu.module__item___dVpuV1",
  "r9": "ContextMenu.module__disabled___dVpuV1",
  "OR": "ContextMenu.module__danger___dVpuV1",
  "Fx": "ContextMenu.module__itemIcon___dVpuV1",
  "IR": "ContextMenu.module__itemLabel___dVpuV1",
  "Ah": "ContextMenu.module__itemWithShortcut___dVpuV1",
  "g$": "ContextMenu.module__itemShortcut___dVpuV1",
  "ED": "ContextMenu.module__itemShortcutHidden___dVpuV1",
  "dP": "ContextMenu.module__itemLabelContainer___dVpuV1",
  "b": "ContextMenu.module__itemLabelText___dVpuV1",
  "Lo": "ContextMenu.module__itemHint___dVpuV1",
  "fV": "ContextMenu.module__submenuCaret___dVpuV1",
  "me": "ContextMenu.module__separator___dVpuV1",
  "Os": "ContextMenu.module__group___dVpuV1",
  "_0": "ContextMenu.module__selectableSection___dVpuV1",
  "dl": "ContextMenu.module__checkboxItem___dVpuV1",
  "fb": "ContextMenu.module__checkboxIndicator___dVpuV1",
  "kv": "ContextMenu.module__checkbox___dVpuV1",
  "xY": "ContextMenu.module__checkboxChecked___dVpuV1",
  "AM": "ContextMenu.module__groupLabel___dVpuV1",
  "HG": "ContextMenu.module__submenuPopover___dVpuV1",
  "a": "ContextMenu.module__submenuScroller___dVpuV1",
  "pT": "ContextMenu.module__quickReactionsGroup___dVpuV1",
  "gV": "ContextMenu.module__quickReactionItem___dVpuV1",
  "z5": "ContextMenu.module__quickReactionShortcut___dVpuV1",
  "dd": "ContextMenu.module__quickReactionTooltipContent___dVpuV1",
  "Vx": "ContextMenu.module__quickReactionTooltipHint___dVpuV1",
  "hH": "ContextMenu.module__emojiSubmenuIcon___dVpuV1",
  "XN": "ContextMenu.module__emojiSubmenuImg___dVpuV1",
};

module.exports = exports;
